import { create } from "zustand";
import zukeeper from "zukeeper";

const initState = {
  user: null,
};

const useUserStore = create(
  zukeeper((set) => ({
    user: null,
    setUser: (newUser) => {
      set(() => ({
        user: newUser,
      }));
    },
    reset: () => set(initState),
  }))
);
window.store = useUserStore;
export default useUserStore;
